import React from "react";

import fairprice_avatar from "images/custom/placeholders/fairprice-avatar.png";
import ProfilePage from "components/Profile/ProfilePage";

import localize from "lang/localize";

/* Custom: fixed fairprice avatar */
class CustomProfilePage extends ProfilePage {
  renderProfile() {
    let name = this.props.name;

    return (
      <div>
        <div className="hide-from-md">
          <div className="pure-u-1-6" />
          <div className="pure-u-1-24" />
          <h2 className="pure-u-7-12 textcenter">{name}</h2>
          <div className="pure-u-1-24" />
          <div className="pure-u-1-6">{this.renderMenuDropdownButton()}</div>
        </div>
        <div className="hide-from-md pure-g profile-container">
          <div className="pure-u-1-3 relative">
            <p className="textcenter">
              {this.props.points.abbreviateNumber()}
              <br />
              {localize("points_just_text", this.props.language)}
            </p>
          </div>
          <div className="pure-u-1-3">
            <span className="square-image-wrapper">
              <span className="square-image circle border-gray-light">
                <img src={fairprice_avatar} alt={name} />
              </span>
            </span>
          </div>
          {this.props.showCompletions ? (
            <div id="completions" className="pure-u-1-3 relative">
              <p className="textcenter">
                {this.props.completions.abbreviateNumber()}
                <br />
                {localize("completions_text", this.props.language)}
              </p>
            </div>
          ) : null}
        </div>

        <div className="hide-below-md pure-g profile-container">
          <div className="pure-u-md-4-24" />
          <div className="pure-u-md-4-24">
            <span className="square-image-wrapper">
              <span className="square-image circle border-gray-light">
                <img src={fairprice_avatar} alt={name} />
              </span>
            </span>
            {this.props.userRankStatusImage && (
              <div id="rankStatus" className="photo-icon-wrap">
                <img
                  className="rank-status"
                  src={this.props.userRankStatusImage}
                  alt={this.props.userRankStatus}
                />
              </div>
            )}
          </div>
          <div className="pure-u-md-12-24 horizontalpadding relative">
            <div className="textcenter">
              <h2>{name}</h2>
              <p className="profile-points-completions">
                {this.props.points.abbreviateNumber() +
                  " " +
                  localize("points_just_text", this.props.language)}
              </p>
              {this.props.showCompletions && (
                <p className="profile-points-completions">
                  {this.props.completions + " "}
                  {localize("completions_text", this.props.language)}
                </p>
              )}
            </div>
          </div>
          <div className="pure-u-md-4-24">
            {this.renderMenuDropdownButton()}
          </div>
        </div>
      </div>
    );
  }
}

export default CustomProfilePage;
